// @flow

import CheckReceivedContainer from './CheckReceivedContainer'

export default CheckReceivedContainer
